// extracted by mini-css-extract-plugin
export default {"label":"Search_label__X-B8m","input":"Search_input__sqCPg"};